import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import Total from './Total';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

export default function TableDetails({
  job,
  currencySymbol,
  jobsInfo,
  jobTotals,
  addCommasToNumber,
  workInProgressNotes,
}) {
  const { items = [] } = job?.extrasWithJob || '';
  const notes = job?.notes || '';
  const widthCount =
    Object.values(jobsInfo)?.filter((item) => item)?.length - 1 || 1;
  const styles = StyleSheet.create({
    details__header__1: {
      width: 47 + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopRightRadius: 0,
    },
    details__body__1: {
      width: 47 + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopRightRadius: 0,
    },
    details__header: {
      width: 70 / widthCount + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopRightRadius: 0,
      textAlign: 'center',
    },
    details__header__item__desc: {
      width: 220 / widthCount + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopRightRadius: 0,
    },
    details__body: {
      width: 70 / widthCount + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopRightRadius: 0,
      textAlign: 'center',
    },
    details__body__item__desc: {
      width: 220 / widthCount + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopRightRadius: 0,
    },

    tableRow: {
      width: '100%',
      margin: 'auto',
      display: 'flex',
      flexDirection: 'row',
    },
    tableColFirstHeader: {
      width: 6 + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 0,
      borderLeftWidth: 0,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopLeftRadius: 0,
      alignItems: 'center',
    },
    tableColFirstBody: {
      width: 6 + '%',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 0,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderBottomWidth: 1,
      borderRightWidth: 0,
      borderTopLeftRadius: 0,
      alignItems: 'center',
    },
    table: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderTopWidth: 0,
      borderRightWidth: 1,
      borderRadius: 0,
      overflow: 'hidden',
      marginTop: 25,
      display: 'block',
      width: 'auto',
    },
    tableCellHeader: {
      margin: 5,
      fontSize: 8,
      fontFamily: 'Roboto',
      fontWeight: '600',
    },
    tableCell: {
      margin: 5,
      fontSize: 7,
      fontFamily: 'Roboto',
      fontWeight: '400',
    },
    display__flex: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
    },
    item__num: {
      fontSize: 6,
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#6D7D8B',
      marginRight: 5,
      marginLeft: 5,
      paddingTop: 2,
    },
    tag: {
      padding: 7,
      paddingTop: 2,
      paddingBottom: 2,
      backgroundColor: 'rgba(231, 236, 244, .8)',
      fontSize: 6,
      fontFamily: 'Roboto',
      fontWeight: '400',
      borderRadius: '100px',
      textTransform: 'capitalize',
    },
    notes__main: {
      backgroundColor: 'rgba(231, 236, 244, .8)',
      borderTopWidth: 1,
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      padding: 10,
    },
    note__heading: {
      fontSize: 7,
      fontFamily: 'Roboto',
      fontWeight: '500',
      paddingBottom: 5,
    },
    note__text: {
      fontSize: 6,
      fontFamily: 'Roboto',
      fontWeight: '400',
    },
  });
  return (
    <>
      <View style={styles.table} wrap>
        <View style={styles.tableRow} wrap>
          <View style={styles.tableColFirstHeader}>
            <Text style={styles.tableCellHeader}>Sr#</Text>
          </View>
          {jobsInfo?.['Item Description'] && (
            <View style={styles.details__header__item__desc}>
              <Text style={styles.tableCellHeader}>Item Description</Text>
            </View>
          )}

          {jobsInfo?.Price && (
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Price</Text>
            </View>
          )}

          {jobsInfo?.['QTY/Hrs'] && (
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>QTY/Hrs</Text>
            </View>
          )}
          {jobsInfo?.Discount && (
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Discount</Text>
            </View>
          )}
          {jobsInfo?.Tax && (
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Tax</Text>
            </View>
          )}
          {jobsInfo?.Total && (
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Total</Text>
            </View>
          )}
        </View>
        {items?.map((item, index) => {
          return (
            <View style={styles.tableRow} key={index++} wrap>
              <View style={styles.tableColFirstBody}>
                <Text style={styles.tableCell}>{index + 1}</Text>
              </View>
              {jobsInfo?.['Item Description'] && (
                <View style={styles.details__body__item__desc}>
                  <View style={styles.display__flex}>
                    <Text style={styles.tableCell}>{item?.description}</Text>
                    {item?.type === 'parts_supplies' && item?.condition ? (
                      <Text style={styles.tag}>{item?.condition}</Text>
                    ) : (
                      <Text />
                    )}
                  </View>
                  {item?.type === 'parts_supplies' &&
                  (item?.partSupplyNo || item?.sku) ? (
                    <>
                      {jobsInfo?.['Item Part Supply Number'] && (
                        <Text style={styles.item__num}>
                          PR-{item?.partSupplyNo || item?.sku}
                        </Text>
                      )}
                    </>
                  ) : item?.type === 'miscellaneous' ? (
                    <Text style={styles.item__num}>Misc.</Text>
                  ) : (
                    <Text style={styles.item__num} />
                  )}
                </View>
              )}

              {jobsInfo?.Price && (
                <View style={styles.details__body}>
                  <Text style={styles.tableCell}>
                    {currencySymbol}
                    {addCommasToNumber(
                      Math.round((+item?.price || 0) * 100) / 100,
                    )}
                  </Text>
                </View>
              )}
              {jobsInfo?.['QTY/Hrs'] && (
                <View style={styles.details__body}>
                  <Text style={styles.tableCell}>
                    {item?.qty} {item?.type === 'labours' && 'Hrs'}
                  </Text>
                </View>
              )}

              {jobsInfo?.Discount && (
                <View style={styles.details__body}>
                  <Text style={styles.tableCell}>
                    {currencySymbol}
                    {addCommasToNumber(
                      Math.round((+item?.discount || 0) * 100) / 100 || 0,
                    )}
                  </Text>
                </View>
              )}
              {jobsInfo?.Tax && (
                <View style={styles.details__body}>
                  <Text style={styles.tableCell}>
                    {currencySymbol}
                    {addCommasToNumber(
                      Math.round((+item?.calculatedTax || 0) * 100) / 100 || 0,
                    )}
                  </Text>
                </View>
              )}

              {/* {jobsInfo?.Total && (
                <View style={styles.details__body}>
                  <Text style={styles.tableCell}>
                    {currencySymbol}
                    {addCommasToNumber(
                      Math.round((+item?.retailPrice || 0) * 100) / 100 || 0,
                    )}
                  </Text>
                </View>
              )} */}
              {jobsInfo?.Total && (
                <View style={styles.details__body}>
                  <Text style={styles.tableCell}>
                    {currencySymbol}
                    {addCommasToNumber(
                      Math.round(
                        (+item?.subTotal + +item?.calculatedTax || 0) * 100,
                      ) / 100 || 0,
                    )}
                  </Text>
                </View>
              )}
            </View>
          );
        })}
        <Total
          data={{ ...job, currencySymbol, jobTotals, addCommasToNumber } || ''}
        />
        {(workInProgressNotes || notes || notes !== null) && (
          <View style={styles.notes__main} wrap={false}>
            <Text style={styles.note__heading}>Notes:</Text>
            <Text style={styles.note__text}>
              {notes === null ? '--' : notes}
            </Text>
          </View>
        )}
      </View>
    </>
  );
}
